import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { DropdownButton, Dropdown, Col } from "react-bootstrap";
import { Box, ButtonStyled, SpanStyled } from "../styled/Elements";
import skyImage from "../../assets/images/png/sky_pattern.png";
import { useTranslation } from "react-i18next";
import { ArrowDown, ArrowUp, WhiteSearchIcon } from "../styled/AllImages";
import { listingTypes, roles, statusTypes } from "../data/data";
import { useUser } from "../../context/userContext";
import { useSearchParams } from "react-router-dom";
import PropertiesApi from "../../services/api/propertiesApi";
import VisitorApi from "../../services/api/visitorApi";
import GeneralRequestCta from "../common/GeneralRequestCta";

const BannerSearchBar = ({
  selectedData,
  selectedCity,
  setSelectedCity,
  selectedDistrict,
  setSelectedDistrict,
  selectedRole,
  setSelectedRole,
  selectedListingType,
  setSelectedListingType,
  selectedPropertyType,
  setSelectedPropertyType,
  selectedPropertyStatus,
  setSelectedPropertyStatus,
  queryData,
}) => {
  const {
    setSearchProfileData,
    searchProfileData,
    setCurrentPage,
    currentPage,
    setTotalPages,
    totalPages,
  } = useUser();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [roleName, setRoleName] = useState(null);
  const [cityName, setCityName] = useState(null);
  const [cityData, setCityData] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState(null);

  const [showAdvanceSearch, setShowAdvanceSearch] = useState(
    queryData?.advance || false
  );
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [perPage, setPerPage] = useState(10);
  const [districts, setDistricts] = useState([]);
  const [btnWidth, setBtnWidth] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [districtSearch, setDistrictSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const isCityAll = selectedCity?.value === "all";
  const cityTitle = isCityAll
    ? t("all")
    : cityData?.find((city) => parseInt(selectedCity?.value) === city?.id)
        ?.label;
  const cityId = isCityAll
    ? null
    : cityData?.find((city) => parseInt(selectedCity?.value) === city?.id)
        ?.value;
  const districtTitle = districts?.find(
    (district) => parseInt(selectedDistrict?.value) === district?.id
  )?.label;
  const propertyTypeTitle = propertyTypes?.find(
    (type) => parseInt(selectedPropertyType?.value) === parseInt(type?.id)
  )?.label;

  const filteredCities = cityData.filter((city) =>
    city.label.toLowerCase().includes(citySearch.toLowerCase())
  );

  const filteredDistricts = districts.filter((dst) =>
    dst.label.toLowerCase().includes(districtSearch.toLowerCase())
  );
  // const searchProfile = async () => {
  //   try {
  //     const response = await visitorAxiosInstance?.post(
  //       `${BASE_URL_VISITOR}/search-profile`
  //       // {
  //       //   city_id: selectedCity?.value,
  //       //   professional_type: selectedRole?.id,
  //       //   neighborhood_id: selectedDistrict?.value,
  //       // }
  //     );
  //     if (response) {
  //       setSearchProfileData(response?.data?.data?.data);
  //     }
  //   } catch (error) {
  //     return error;
  //   }
  // };
  const updateMultipleParams = (params = {}) => {
    const newParams = new URLSearchParams(searchParams);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        newParams.set(key, value);
      }
    });
    setSearchParams(newParams);
  };

  const handleResetSearch = () => {
    setSelectedCity(null);
    setSelectedRole(null);
    setSelectedDistrict(null);
    setSelectedListingType(null);
    setSelectedPropertyType(null);
    setSelectedPropertyStatus(null);
    setShowAdvanceSearch(false);

    updateMultipleParams({
      role: null,
      city: null,
      listing_type: null,
      property_type: null,
      property_status: null,
      advance: false
    });
  };

  const searchProfile = async (
    page = 1,
    roleId,
    cityId,
    listingTypeId,
    propertyTypeId,
    propertyStatusId
  ) => {
    const roleVal = roleId || selectedRole?.id;
    const cityVal = cityId || selectedCity?.value;
    const listingVal = listingTypeId || selectedListingType?.id;
    const propVal = propertyTypeId || selectedPropertyType?.value;
    const statusVal = propertyStatusId || selectedPropertyStatus?.id;
    const isAllCities = cityVal === "all";
    const city = isAllCities
      ? t("all")
      : cityData?.find((c) => Number(c?.value) === Number(cityVal))?.label ||
        "";
    const hasAdvanceFields = !!(listingVal || propVal || statusVal);
    const searchParams = {
      // Only advance when the advance UI is open and a field is set
      is_advance: showAdvanceSearch && hasAdvanceFields ? "1" : "0",
      include_incomplete: 1,
    };
    if (roleVal) searchParams.professional_type = roleVal;
    // Omit city_id when "All" so every matching broker is returned
    if (cityVal && !isAllCities) searchParams.city_id = cityVal;
    if (showAdvanceSearch) {
      if (listingVal) searchParams.listing_type_id = listingVal;
      if (propVal) searchParams.listing_property_type_id = propVal;
      if (statusVal) searchParams.property_status = statusVal;
    }
    if (page) searchParams.page = page;

    try {
      const body = await VisitorApi.searchProfile(searchParams);

      const result = body?.data;

      updateMultipleParams({
        role: roleVal,
        city: cityVal || null,
        listing_type: listingVal,
        property_type: propVal,
        property_status: statusVal,
      });
      setCityName(city);
      setRoleName(
        parseInt(selectedRole?.id) === 3
          ? t("brokers_and_marketers")
          : parseInt(selectedRole?.id) === 2
          ? t("brokers")
          : t("marketers")
      );

      if (body?.code === 200 && result) {
        const formattedData = result?.data?.map((item) => ({
          ...item,
          city:
            (!isAllCities &&
              item?.personal_information?.we_operate_in_data &&
              item.personal_information.we_operate_in_data.find(
                (c) => Number(c?.id) === Number(cityVal)
              )?.[i18n.language === "en" ? "name_en" : "name_ar"]) ||
            showAdvanceSearch
              ? city
              : "",
        }));

        setSearchProfileData(formattedData);
        setCurrentPage(result?.meta?.current_page || 1);
        setTotalPages(Math.ceil(result?.meta?.total / result?.meta?.per_page));
      } else if (body?.code === 204) {
        setSearchProfileData([]);
        setCurrentPage(0);
        setTotalPages(0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getCityData = async () => {
    try {
      const body = await VisitorApi.getCitiesList();
      if (body?.data) {
        setCityData(
          body?.data?.map((city) => ({
            ...city,
            value: city?.id,
            label: isRTL ? city?.name_ar : city?.name_en,
          }))
        );
      }
    } catch (error) {}
  };

  const getDistrict = async (cityId) => {
    try {
      const body = await VisitorApi.getDistricts(cityId);
      const data = body?.data;

      if (Array.isArray(data) && data.length > 0) {
        setDistricts(
          data.map((dst) => ({
            ...dst,
            value: dst.id,
            label: isRTL ? dst.name_ar : dst.name_en,
          }))
        );
      } else {
        setDistricts([]);
      }
    } catch (error) {
      setDistricts([]);
    }
  };

  const getPropertyTypes = async () => {
    try {
      const response = await PropertiesApi.getListingPropertyTypes();
      if (response?.data) {
        setPropertyTypes(
          response?.data &&
            response?.data
              ?.filter((item) => item?.id != 15)
              ?.map((item) => {
                return {
                  ...item,
                  label: isRTL ? item?.ar_name : item?.en_name,
                  value: item?.id,
                };
              })
        );
      }
    } catch (error) {
      console.log(error.message);
      setPropertyTypes([]);
    }
  };

  useEffect(() => {
    getCityData();
    getPropertyTypes();
  }, [i18n.language]);

  useEffect(() => {
    if (cityId) {
      getDistrict(cityId);
    } else {
      setDistricts([]);
    }
  }, [cityId, i18n.language]);

  useEffect(() => {
    const handleResize = () => {
      const sWidth = window.innerWidth;
      if (sWidth <= 627) {
        setBtnWidth("100%");
      } else {
        setBtnWidth("");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (selectedRole?.id && selectedCity?.value)
      searchProfile(
        currentPage,
        selectedRole?.id,
        selectedCity?.value,
        selectedListingType?.id,
        selectedPropertyType?.value,
        selectedPropertyStatus?.id
      );
  }, [currentPage, isRTL]);
  useEffect(() => {
    if (cityData?.length > 0 && queryData?.role && queryData?.city)
      searchProfile(
        currentPage,
        queryData?.role,
        queryData?.city,
        queryData?.listingType,
        queryData?.propertyType,
        queryData?.propertyStatus
      );
  }, [cityData]);

  useEffect(() => {
    if (queryData?.role) {
      const currentRole = roles?.find((role) => role?.id == queryData?.role);
      setRoleName(
        parseInt(selectedRole?.id) === 3
          ? t("brokers_and_marketers")
          : parseInt(selectedRole?.id) === 2
          ? t("brokers")
          : t("marketers")
      );
      setSelectedRole(currentRole);
    }
    if (queryData?.city && cityData?.length > 0) {
      if (queryData.city === "all") {
        setCityName(t("all"));
        setSelectedCity({ id: "all", value: "all", label: t("all") });
      } else {
        const currentCity = cityData?.find(
          (city) => city?.value == queryData?.city
        );
        setCityName(currentCity?.label);
        setSelectedCity(currentCity);
      }
    }
    if (queryData?.listingType) {
      const currentType = listingTypes?.find(
        (type) => type?.id == queryData?.listingType
      );
      setSelectedListingType(currentType);
    }
    if (queryData?.propertyType && propertyTypes && propertyTypes?.length > 0) {
      const currentType = propertyTypes?.find(
        (type) => type?.value == queryData?.propertyType
      );
      setSelectedPropertyType(currentType);
    }
    if (queryData?.propertyStatus) {
      const currentType = statusTypes?.find(
        (type) => type?.id == queryData?.propertyStatus
      );
      setSelectedPropertyStatus(currentType);
    }
  }, [cityData, propertyTypes]);

  return (
    <>
      <BannerWrapper lang={i18n.language}>
        <BannerContainer>
          <SearchAndCtaRow>
            <SearchBarWrapper>
              <SearchBar>
              <Col>
                <Box className="d-flex align-items-center">
                  <InputGroup lang={i18n.language}>
                    <Label lang={i18n.language}>
                      {t("looking_for")}{" "}
                      <span style={{ color: "var(--themeColorSecondary)" }}>
                        *
                      </span>
                    </Label>
                    <SubLabel lang={i18n.language}>
                      {
                        selectedRole
                          ? t(selectedRole.role)
                          : t("select_professional_type")}
                    </SubLabel>
                    <StyledDropdownButton
                      title={
                        selectedRole
                          ? t(selectedRole.role)
                          : t("select_professional_type")
                      }
                      lang={i18n.language}
                      id="property-type"
                      className="property-type"
                    >
                      {roles.map((role) => (
                        <Dropdown.Item
                          onClick={() => setSelectedRole(role)}
                          key={role?.id}
                        >
                          {t(role?.role)}
                        </Dropdown.Item>
                      ))}
                    </StyledDropdownButton>
                  </InputGroup>

                  {/* City Dropdown with Search */}
                  <InputGroup lang={i18n.language}>
                    <Label lang={i18n.language}>
                      {t("city")}{" "}
                      <span style={{ color: "var(--themeColorSecondary)" }}>
                        *
                      </span>
                    </Label>
                    <SubLabel lang={i18n.language}>
                      {cityTitle
                        ? cityTitle
                        : selectedCity?.label
                        ? selectedCity?.label
                        : t("select_city")}
                    </SubLabel>
                    <StyledDropdownButton
                      title={
                        selectedCity ? selectedCity.label : t("select_city")
                      }
                      lang={i18n.language}
                      className="property-type"
                      id="city"
                    >
                      <div className="dropdown-search-wrapper">
                        <input
                          type="text"
                          style={{
                            color: "var(--text)",
                            borderRadius: "8px",
                            border: "0.5px solid lightgray",
                            padding: "2px 5px",
                            width: "100%",
                          }}
                          value={citySearch}
                          onChange={(e) => setCitySearch(e.target.value)}
                          placeholder={t("search")}
                        />
                      </div>
                      <Dropdown.Item
                        key="all"
                        onClick={() => {
                          setSelectedCity({
                            id: "all",
                            value: "all",
                            label: t("all"),
                          });
                          setSelectedDistrict(null);
                          setDistricts([]);
                          setCitySearch("");
                        }}
                      >
                        {t("all")}
                      </Dropdown.Item>
                      {filteredCities &&
                        filteredCities?.length > 0 &&
                        filteredCities?.map((city) => (
                          <Dropdown.Item
                            title={
                              parseInt(selectedCity?.value) === city?.id
                                ? city?.label
                                : t("select_city")
                            }
                            key={city?.id}
                            onClick={() => {
                              setSelectedCity(city);
                              setSelectedDistrict(null);
                              setDistricts([]);
                              getDistrict(city?.value);
                            }}
                          >
                            {city?.label}
                          </Dropdown.Item>
                        ))}
                    </StyledDropdownButton>
                  </InputGroup>

                  {/* District Dropdown with Search */}
                  <InputGroup lang={i18n.language}>
                    <Label lang={i18n.language}>{t("within")}</Label>
                    <SubLabel lang={i18n.language}>
                      {districtTitle
                        ? districtTitle
                        : selectedDistrict?.label
                        ? selectedDistrict?.label
                        : isCityAll
                        ? t("select_neighborhood")
                        : cityTitle || t("select_neighborhood")}
                    </SubLabel>
                    <StyledDropdownButton
                      lang={i18n.language}
                      className="property-type"
                      id="neighborhood"
                      disabled={!selectedCity || isCityAll}
                      style={{
                        pointerEvents:
                          !selectedCity || isCityAll ? "none" : "auto",
                        opacity: !selectedCity || isCityAll ? 0.6 : 1,
                      }}
                    >
                      <div
                        style={{ zIndex: "1" }}
                        className="dropdown-search-wrapper"
                      >
                        <input
                          style={{
                            color: "var(--text)",
                            borderRadius: "8px",
                            border: "0.5px solid lightgray",
                            padding: "2px 5px",
                            width: "100%",
                          }}
                          type="text"
                          value={districtSearch}
                          onChange={(e) => setDistrictSearch(e.target.value)}
                          placeholder={t("search")}
                        />
                      </div>
                      {filteredDistricts && filteredDistricts?.length > 0 ? (
                        filteredDistricts?.map((dst) => (
                          <Dropdown.Item
                            onClick={() => setSelectedDistrict(dst)}
                            key={dst?.id}
                          >
                            {dst?.label}
                          </Dropdown.Item>
                        ))
                      ) : (
                        <Dropdown.Item>{t("no_neighborhood")}</Dropdown.Item>
                      )}
                    </StyledDropdownButton>
                  </InputGroup>
                </Box>

                {showAdvanceSearch && (
                  <Box className="d-flex align-items-center mt-3">
                    <InputGroup lang={i18n.language}>
                      <Label lang={i18n.language}>{t("listing_type")} </Label>
                      <SubLabel lang={i18n.language}>
                        {t(selectedListingType?.label) ||
                          t("select_listing_type")}
                      </SubLabel>
                      <StyledDropdownButton
                        lang={i18n.language}
                        id="property-type"
                        className="property-type"
                      >
                        {listingTypes?.map((type) => (
                          <Dropdown.Item
                            onClick={() => setSelectedListingType(type)}
                            key={type?.id}
                          >
                            {t(type?.label)}
                          </Dropdown.Item>
                        ))}
                        {/* <Dropdown.Item>Villa</Dropdown.Item>
                                <Dropdown.Item>Office</Dropdown.Item> */}
                      </StyledDropdownButton>
                    </InputGroup>

                    <InputGroup lang={i18n.language}>
                      <Label lang={i18n.language}>{t("property_type")} </Label>
                      <SubLabel lang={i18n.language}>
                        {propertyTypeTitle || t("select_property_type")}
                      </SubLabel>
                      <StyledDropdownButton
                        lang={i18n.language}
                        className="property-type"
                        id="property-type"
                        title={propertyTypeTitle || t("select_property_type")}
                      >
                        {propertyTypes?.length > 0 ? (
                          propertyTypes.map((type) => (
                            <Dropdown.Item
                              key={type.id}
                              onClick={() => {
                                setSelectedPropertyType(type);
                              }}
                            >
                              {type.label}
                            </Dropdown.Item>
                          ))
                        ) : (
                          <Dropdown.Item disabled>{t("no_data")}</Dropdown.Item>
                        )}
                      </StyledDropdownButton>
                    </InputGroup>

                    <InputGroup lang={i18n.language}>
                      <Label lang={i18n.language}>{t("property_status")}</Label>
                      <SubLabel lang={i18n.language}>
                        {t(selectedPropertyStatus?.label) ||
                          t("select_property_status")}
                      </SubLabel>
                      <StyledDropdownButton
                        lang={i18n.language}
                        className="property-type"
                        id="property-type"
                        title={
                          t(selectedPropertyStatus?.label) ||
                          t("select_property_status")
                        }
                      >
                        {statusTypes.length > 0 ? (
                          statusTypes.map((type) => (
                            <Dropdown.Item
                              key={type.id}
                              onClick={() => {
                                setSelectedPropertyStatus(type);
                              }}
                            >
                              {t(type.label)}
                            </Dropdown.Item>
                          ))
                        ) : (
                          <Dropdown.Item disabled>{t("no_data")}</Dropdown.Item>
                        )}
                      </StyledDropdownButton>
                    </InputGroup>
                  </Box>
                )}
                <Box
                  style={{
                    textAlign: "start",
                    cursor: "pointer",
                    width: "fit-content",
                  }}
                  className="d-flex align-items-center mx-2 mt-2 gap-1 advance-btn"
                  onClick={() => setShowAdvanceSearch(!showAdvanceSearch)}
                >
                  <SpanStyled size="14px" color="var(--themeColorSecondary)">
                    {t("advance_search")}
                  </SpanStyled>{" "}
                  {showAdvanceSearch ? (
                    <ArrowDown width="18px" />
                  ) : (
                    <ArrowUp width="18px" />
                  )}
                </Box>
              </Col>
              {/* Search Button */}
              <SearchButtonWrapper>
                <Box>
                  <ButtonStyled
                    width={btnWidth}
                    icon={WhiteSearchIcon}
                    label={t("search_property")}
                    color="var(--white)"
                    bg="var(--themeColorSecondary)"
                    className={""}
                    size="16px"
                    padding="11px 20px"
                    onClick={() => searchProfile()}
                  />
                  <Box className="mt-2">
                    <SpanStyled
                      size="14px"
                      color="var(--themeColorSecondary)"
                      style={{ cursor: "pointer" }}
                      onClick={handleResetSearch}
                    >
                      {t("reset_search")}
                    </SpanStyled>
                  </Box>
                </Box>
              </SearchButtonWrapper>
            </SearchBar>
            </SearchBarWrapper>
            <GeneralRequestCta variant="inline" />
          </SearchAndCtaRow>
        </BannerContainer>
        {roleName && cityName && (
          <h2 className="title">
            {t("found")}{" "}
            {roleName == t("both") ? t("brokers_and_marketers") : t(roleName)}
            {selectedCity?.value !== "all" ? (
              <>
                {" "}
                {t("in")} {t(cityName)}
              </>
            ) : null}
          </h2>
        )}
        {/* <h2 className="title">
            {t("found")}{" "}
            {selectedRole
              ? parseInt(selectedRole?.id) === 3
                ? t("brokers_and_marketers")
                : parseInt(selectedRole?.id) === 2
                ? t("brokers")
                : t("marketers")
              : selectedData?.role?.id === 3
              ? t("brokers_and_marketers")
              : selectedData?.role?.id === 2
              ? t("brokers")
              : t("marketers")}{" "}
            {t("in")} {cityTitle ? cityTitle : selectedData?.city?.label}
          </h2> */}
      </BannerWrapper>
      {/* <PaginationComponent
  currentPage={currentPage}
  totalPages={totalPages}
  onPageChange={(page) => setCurrentPage(page)}
/> */}
    </>
  );
};

export default BannerSearchBar;

export const BannerWrapper = styled.section`
  min-height: 100%;
  height: 100%;
  background-repeat: no-repeat;
  width: 100%;
  padding: 12px;
  overflow: visible;
  background-image: url(${skyImage});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .title {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 35px;
    /* padding-bottom: 20px; */
    font-size: 24px;
    font-family: ${({ lang }) =>
      lang === "en" ? "var(--heavy)" : "var(--arExtraBold)"};
    color: var(--darkGrey);
  }
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.5);
    z-index: 1;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: -30px;
    left: 0;
    right: 0;
    height: 120px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.01),
      rgba(255, 255, 255, 0.8)
    );
    box-shadow: none;
    pointer-events: none;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
  @media (max-width: 991px) {
    min-height: 100%;
    height: 100%;
  }
`;
const BannerContainer = styled.section`
  /* padding: 60px 20px; */
  max-width: 1180px;
  text-align: center;
  height: fit-content;
  padding: 10px;
  margin-top: 5rem;
  border-radius: 20px;
  background: #ffffffb1;
  margin-left: auto;
  margin-right: auto;
  /* box-shadow: inset -18px 0 15px rgba(0, 0, 0, 0.1); */
  z-index: 3;
  border: 1px solid #fff;
  @media (max-width: 767px) {
    border: none;
    background: none;
  }

  .advance-btn {
    svg {
      [stroke] {
        stroke: var(--themeColorSecondary);
      }
    }
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 10px;
  color: var(--themeColorSecondary);
  font-family: ${({ lang }) =>
    lang === "en" ? "var(--heavy)" : "var(--arExtraBold)"};
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: var(--themeColor);
  margin-bottom: 30px;
`;

const SearchAndCtaRow = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 14px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SearchBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 855px;
  margin: 0;
`;

const SearchBar = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  background-color: transparent;
  border-radius: 16px;
  padding: 12px;
  position: relative;
  z-index: 1;
  gap: 12px;
  border: 1px solid transparent;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(to right, #6aeef0, #ffffff 40%, #ffffff 60%, #acceaa)
      border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 767px) {
    background: none;
    border: 1px solid #fff;
    background: #ffffffb1;
  }

  @media (max-width: 627px) {
    align-items: stretch;
  }
  @media (max-width: 425px) {
    padding: 12px 6px;
  }
`;

const InputGroup = styled.div`
  flex: 1;
  position: relative;
  padding: 0 12px;
  text-align: left;
  .property-type {
    position: absolute;
    height: 100%;
    right: 3%;
    bottom: 4%;
    background: transparent !important;
  }

  &:not(:first-child) {
    border-left: ${({ lang }) => (lang === "ar" ? "none" : "1px solid #ccc")};
    border-right: ${({ lang }) => (lang === "en" ? "none" : "1px solid #ccc")};
  }

  @media (max-width: 425px) {
    padding: 0 5px;
  }
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
  color: var(--text);
  text-align: ${({ lang }) => (lang === "en" ? "left" : "right")};
  @media (max-width: 482px) {
    font-size: 0.75rem;
  }
`;

const SubLabel = styled.div`
  font-size: 0.75rem;
  color: var(--lightGrey);
  white-space: nowrap;
  margin-bottom: 6px;
  text-align: ${({ lang }) => (lang === "en" ? "left" : "right")};
  @media (max-width: 482px) {
    font-size: 0.6rem;
  }
`;

const StyledDropdownButton = styled(DropdownButton)`
  width: 100%;
  border: none !important;
  background: white !important;
  padding: 0 !important;
  color: #333;
  border-radius: 0;
  box-shadow: none;
  font-size: 1rem;
  margin-top: 4px;
  height: 100%;
  position: relative;

  .dropdown-search-wrapper {
    width: 100%;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: center;
    padding: 5px 12px;
  }

  &::after {
    display: none !important;
  }

  &:focus,
  &:active {
    box-shadow: none !important;
    outline: none !important;
  }

  .dropdown-toggle {
    background-color: transparent !important;
    border: none !important;
    padding: 0;
    height: 100%;
    width: 100%;
    color: transparent !important;
    position: relative; // Add this to create a new stacking context
  }

  /* Apply direction based on props.lang */
  .dropdown-menu {
    width: 100%;
    max-height: 179px;
    height: fit-content;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 12px !important;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    margin-top: 12px;
    border: none !important;
    z-index: 1050 !important;

    direction: ${({ lang }) => (lang === "ar" ? "rtl" : "ltr")};
    text-align: ${({ lang }) => (lang === "ar" ? "right" : "left")};

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  .dropdown-item {
    padding: 10px 15px;
    font-size: 0.95rem;
    color: #333;
    background-color: white !important;
    text-align: ${({ lang }) => (lang === "ar" ? "right" : "left")};
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    background-color: #f1f1f1 !important;
    color: #000 !important;
  }
`;

const SearchButton = styled.button`
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 22px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  margin-left: 12px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #218838;
  }

  svg {
    font-size: 20px;
  }
`;

const SearchButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 8px 12px;

  @media (max-width: 627px) {
    justify-content: center;
    width: 100%;
  }
`;
